<template>
  <v-app id="inspire" style="height: 100%;min-height: 100%;">
<!--    <v-system-bar app>-->
<!--      <v-spacer></v-spacer>-->

<!--      <v-icon>mdi-square</v-icon>-->

<!--      <v-icon>mdi-circle</v-icon>-->

<!--      <v-icon>mdi-triangle</v-icon>-->
<!--    </v-system-bar>-->

    <v-main style="height: 100%;padding-bottom: 0;">
      <router-view/>
    </v-main>

    <v-footer app absolute>
      <top-nav/>
    </v-footer>
  </v-app>
</template>

<script>
  import TopNav from "./components/TopNav";
  export default {
    components: {TopNav},
    data: () => ({}),
  }
</script>



// WEBPACK FOOTER //
// src/App.vue